import { Link } from 'react-router-dom';
import Reveal from '../../../shared/Reveal/Reveal';
import { useContactPartnerContent } from '../../../../hooks/useContactPartnerContent';
import './LookingForPartner.css';

const LookingForPartner = () => {
  const { content, isLoading } = useContactPartnerContent();

  if (isLoading || !content) {
    return null;
  }

  const { title, text, cta } = content;

  return (
    <section className="looking-for-partner">
      <div className="looking-for-partner__inner">
        <Reveal className="looking-for-partner__content">
          <h2 className="looking-for-partner__title">{title}</h2>
          {text ? <p className="looking-for-partner__text">{text}</p> : null}
          {cta?.text && cta?.url ? (
            <Link to={cta.url} className="looking-for-partner__cta luxury-btn">
              {cta.text}
            </Link>
          ) : null}
        </Reveal>
      </div>
    </section>
  );
};

export default LookingForPartner;
